import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgbcl-registration-marketing-placeholder',
  templateUrl: './registration-marketing-placeholder.component.html',
  styleUrls: ['./registration-marketing-placeholder.component.scss'],
})
export class RegistrationMarketingPlaceholderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
